import { AbstractControl, ValidatorFn } from '@angular/forms';
import {
    ButtonConfig,
    ButtonVariant,
} from 'src/app/common/components/core/button/button.component';

const continueButtonConfig: ButtonConfig = {
  text: 'Continue',
  variant: ButtonVariant.PRIMARY,
};
const okButtonConfig: ButtonConfig = {
  text: 'Ok',
  variant: ButtonVariant.PRIMARY,
};
const signatureValidator: ValidatorFn = (formGroup: AbstractControl) => {
  const signature = formGroup.get('signature');
  const confirmSignature = formGroup.get('confirmSignature');
  if (!signature?.touched && !confirmSignature?.touched) {
    return null;
  }
  return signature?.value === confirmSignature?.value
    ? null
    : { signatureMismatch: true };
};
const bothSignaturesPresent: ValidatorFn = (
  formGroup: AbstractControl
) => {
  const signature = formGroup.get('signature');
  const confirmSignature = formGroup.get('confirmSignature');
  if (!signature?.touched && !confirmSignature?.touched) {
    return null;
  }
  return signature?.value && confirmSignature?.value
    ? null
    : { missingSignature: true };
};

export {
    bothSignaturesPresent,
    continueButtonConfig,
    okButtonConfig,
    signatureValidator
};

